import React from "react"

import { SearchspringCollectionProvider } from "@app/scripts/providers/searchspring"
import { CollectionBanner } from "@app/scripts/components/collection-banner"
import { FilterSortDrawer } from "@app/scripts/components/filter-sort-drawer"
import { ResultGrid } from "@app/scripts/components/result-grid"
import { ResultFooter } from "@app/scripts/components/result-footer"

type CollectionData = {
  collection: {
    handle: string
  }
}

export type Props = {
  collectionData: CollectionData
  sort?: string
  filters?: string
  page?: string
}

export function CollectionGrid({ collectionData, sort, filters, page }: Props) {
  const { collection } = collectionData

  return (
    <SearchspringCollectionProvider
      category="products"
      handle={collection?.handle}
      resultsPerPage="24"
      sort={sort && sort}
      filters={filters && filters.split(",")}
      page={page && page}
    >
      <CollectionBanner collectionData={collectionData} />
      <FilterSortDrawer />
      <ResultGrid />
      <ResultFooter />
    </SearchspringCollectionProvider>
  )
}
